export default {
      id: "rounded-border-usage",
      viewBox: "0 0 50 50",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#rounded-border",
      toString: function () {
        return this.url;
      }
    }